import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Project from '../../../Projects/Project/Project';

const RecentProjects = () => {
    const [projects, setProjects] = useState([])
    useEffect(() => {
        fetch('/fakedata.json')
            .then(res => res.json())
            .then(data => setProjects(data.slice(0, 3)))

    }, [])
    return (
        <Container className='text-start my-5'>
            <div className=''>
                <h1 >My Most Recent Project</h1>
                <hr className="w-50" />
            </div>

            <Row>
                {
                    projects.map(project => <Project key={project.id} project={project} ></Project>)
                }
            </Row>
        </Container>
    );
};

export default RecentProjects;